import React from 'react';
const painPoints = [{
  icon: '😴',
  title: 'Sin dormir desde hace semanas',
  description: 'Llevas meses durmiendo en bloques de 2 horas. El agotamiento afecta tu trabajo, tu relación y tu salud mental.'
}, {
  icon: '😰',
  title: 'Ansiedad por el desarrollo',
  description: '¿Está alcanzando sus hitos? ¿Debería ya hacer esto? La comparación constante te consume cada día.'
}, {
  icon: '📱',
  title: 'Información contradictoria',
  description: 'Buscas en Google a las 3 AM y cada resultado dice algo diferente. Más información, más confusión.'
}, {
  icon: '💸',
  title: 'Gastos que no terminan',
  description: 'Juguetes que no usa, gadgets que prometían milagros y libros que nunca terminaste de leer.'
}];
export function PainSection() {
  return <section className="bg-white py-20 px-5" data-id="element-191">
      <div className="max-w-[900px] mx-auto" data-id="element-192">
        {/* Section header */}
        <div className="text-center mb-14" data-id="element-193">
          <span className="inline-block bg-red-50 text-red-400 text-[11px] font-sans font-bold tracking-[2.5px] uppercase py-[7px] px-[18px] rounded-full mb-5" data-id="element-194">
            ⚠️ ¿Te suena familiar?
          </span>
          <h2 className="text-[clamp(28px,4vw,42px)] text-[#2c1810] leading-[1.25] font-bold font-serif" data-id="element-195">
            El primer año es hermoso…
            <br data-id="element-196" />
            <span className="text-[#B76E79] italic font-normal" data-id="element-197">
              pero nadie te dijo lo difícil que sería.
            </span>
          </h2>
        </div>

        {/* Pain points grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-198">
          {painPoints.map((point, idx) => <div key={idx} className="bg-[#faf7f4] border border-[#ede5df] rounded-2xl p-7 flex flex-col gap-3 shadow-[0_2px_12px_rgba(0,0,0,0.04)] hover:shadow-[0_4px_20px_rgba(0,0,0,0.08)] transition-shadow" data-id="element-199">
              <span className="text-3xl" data-id="element-200">{point.icon}</span>
              <h3 className="text-lg font-bold text-[#2c1810] font-sans m-0" data-id="element-201">
                {point.title}
              </h3>
              <p className="text-[15px] leading-[1.75] text-[#5a4a42] font-sans m-0" data-id="element-202">
                {point.description}
              </p>
            </div>)}
        </div>

        {/* Bottom emotional line */}
        <p className="text-center mt-12 text-lg text-[#7a5a50] italic font-serif leading-relaxed max-w-[600px] mx-auto" data-id="element-203">
          "Si sientes que estás improvisando cada día…{' '}
          <strong className="text-[#2c1810]" data-id="element-204">no es tu culpa.</strong> Nadie te
          dio el manual. Hasta ahora."
        </p>
      </div>
    </section>;
}